var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import React from 'react';
function escapeRegex(str) {
    return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
function replaceRegex(tag, key) {
    return new RegExp(escapeRegex("" + tag.start + key + tag.end), 'g');
}
function isCastableToString(element) {
    return typeof element === 'string' || typeof element === 'number';
}
function isNotAnEmptyString(s) {
    return typeof s !== 'string' || s.length > 0;
}
function combineNodes(_a, s) {
    var _b = __read(_a), a = _b[0], rest = _b.slice(1);
    return isCastableToString(s) && isCastableToString(a)
        ? __spread([s + a], rest) : __spread([s, a], rest);
}
function checkComponentForKey(component) {
    if (React.isValidElement(component) && !component.key) {
        console.error('When you define a React component or HTML element as the value of an interpolation, you need to give it a unique `key` prop.');
    }
}
export function interpolate(string, interpolations, tag) {
    if (string === void 0) { string = ''; }
    if (interpolations === void 0) { interpolations = {}; }
    if (tag === void 0) { tag = { start: '[', end: ']' }; }
    function replace(interpolationKeys, input) {
        var _a, key, remaining, pieces;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(interpolationKeys.length === 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, input];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
                case 2:
                    _a = __read(interpolationKeys), key = _a[0], remaining = _a.slice(1);
                    pieces = (input || '').split(replaceRegex(tag, key));
                    return [5 /*yield**/, __values(replace(remaining, pieces.shift()))];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    if (!(pieces.length > 0)) return [3 /*break*/, 7];
                    checkComponentForKey(interpolations[key]);
                    return [4 /*yield*/, interpolations[key]];
                case 5:
                    _b.sent();
                    return [5 /*yield**/, __values(replace(remaining, pieces.shift()))];
                case 6:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 7: return [2 /*return*/];
            }
        });
    }
    var keys = Object.keys(interpolations);
    var segments = replace(keys, string);
    return Array.from(segments)
        .reduceRight(combineNodes, [''])
        .filter(isNotAnEmptyString);
}
//# sourceMappingURL=interpolate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/interpolate.js
// module id = 578
// module chunks = 0